import { DomainSettings } from '@environments/model';
import {
  LANGUAGE_FALLBACK,
  LanguageDefinition,
  LANGUAGES,
  RegionAvailable,
  RegionDefinition,
  REGIONS,
} from '@shared/services/language/registry';

export interface CurrentLanguage {
  readonly region: RegionDefinition;
  /** The language of the prefix, or the domain default when the path is not served. */
  readonly language: LanguageDefinition;
  /** False when the prefix designates no language published on this domain: the page answers a 404. */
  readonly served: boolean;
}

/** `url` is a pathname or a router URL, whose query and fragment are ignored. */
export function resolveCurrentLanguage(
  hostname: string,
  url: string,
  domains: Readonly<Record<RegionAvailable, Pick<DomainSettings, 'publishedLanguages'>>>
): CurrentLanguage {
  const prefix = url.split(/[/?#]/)[1];
  const prefixLanguage =
    Object.values(LANGUAGES).find((candidate) => candidate.urlPrefix === prefix) ?? LANGUAGES[LANGUAGE_FALLBACK];
  const region =
    Object.values(REGIONS).find(
      ({ domain, devHost }) => hostname === devHost || hostname === domain || hostname.endsWith(`.${domain}`)
    ) ?? REGIONS[prefixLanguage.region];
  const published = domains[region.region].publishedLanguages;
  const served = published.includes(prefixLanguage.locale);
  return { region, language: served ? prefixLanguage : LANGUAGES[published[0]], served };
}
